// Generated by tools/design-tokens from design/figma. Do not edit.

export interface GlyphPath {
  /** Path data in the vector's own box. */
  d: string;
  /** Where that box sits in the 24 × 24 glyph. */
  x: number;
  y: number;
  /** Filled as well as stroked. */
  fill?: boolean;
}

export const glyphs = {
  'info': [
    { d: 'M19 10C19 14.971 14.971 19 10 19C5.029 19 1 14.971 1 10C1 5.029 5.029 1 10 1C14.971 1 19 5.029 19 10Z', x: 2, y: 2 },
    { d: 'M1 1V6', x: 11, y: 10 },
    { d: 'M1 1H1.01', x: 11.005, y: 6.5 },
  ],
  'check': [
    { d: 'M19 10C19 14.971 14.971 19 10 19C5.029 19 1 14.971 1 10C1 5.029 5.029 1 10 1C14.971 1 19 5.029 19 10Z', x: 2, y: 2 },
    { d: 'M1 4L3.8 6.8L9.2 1', x: 6.6, y: 8.4 },
  ],
  'alert': [
    { d: 'M19 10C19 14.971 14.971 19 10 19C5.029 19 1 14.971 1 10C1 5.029 5.029 1 10 1C14.971 1 19 5.029 19 10Z', x: 2, y: 2 },
    { d: 'M1 1V6.5', x: 11, y: 6.25 },
    { d: 'M1 1H1.01', x: 11.005, y: 15.5 },
  ],
  'pending': [
    { d: 'M10 1C8.22 1 6.48 1.528 5 2.517C3.52 3.506 2.366 4.911 1.685 6.556C1.004 8.2 0.826 10.01 1.173 11.756C1.52 13.502 2.377 15.105 3.636 16.364C4.895 17.623 6.498 18.48 8.244 18.827C9.99 19.174 11.8 18.996 13.444 18.315C15.089 17.634 16.494 16.48 17.483 15C18.472 13.52 19 11.78 19 10', x: 2, y: 2 },
  ],
  'clock': [
    { d: 'M19 10C19 14.971 14.971 19 10 19C5.029 19 1 14.971 1 10C1 5.029 5.029 1 10 1C14.971 1 19 5.029 19 10Z', x: 2, y: 2 },
    { d: 'M1 1V6L4.5 8', x: 10.75, y: 6 },
  ],
  'lock': [
    { d: 'M3 1H13C14.105 1 15 1.895 15 3V9C15 10.105 14.105 11 13 11H3C1.895 11 1 10.105 1 9V3C1 1.895 1.895 1 3 1Z', x: 4, y: 10 },
    { d: 'M1 8V5C1 3.939 1.421 2.922 2.172 2.172C2.922 1.421 3.939 1 5 1C6.061 1 7.078 1.421 7.828 2.172C8.579 2.922 9 3.939 9 5V8', x: 7, y: 3 },
  ],
  'crown': [
    { d: 'M1 1H17', x: 3, y: 17 },
    { d: 'M2.5 11L1 3L6 7L10 1L14 7L19 3L17.5 11H2.5Z', x: 2, y: 4 },
  ],
  'chevron-down': [
    { d: 'M1 1L7 7L13 1', x: 5, y: 8 },
  ],
  'chevron-up': [
    { d: 'M0.707 7.414L6.707 1.414L12.707 7.414', x: 5, y: 7.5 },
  ],
  'undo': [
    { d: 'M6 11L1 6L6 1', x: 3, y: 3 },
    { d: 'M1 1H11.5C12.959 1 14.358 1.579 15.389 2.611C16.421 3.642 17 5.041 17 6.5C17 7.959 16.421 9.358 15.389 10.389C14.358 11.421 12.959 12 11.5 12H8', x: 3, y: 8 },
  ],
  'trash': [
    { d: 'M1 1H17', x: 3, y: 6 },
    { d: 'M1 1V7', x: 9, y: 10 },
    { d: 'M1 1V7', x: 13, y: 10 },
    { d: 'M1 1L2 14H12L13 1', x: 5, y: 6 },
    { d: 'M1 4V1H7V4', x: 8, y: 3 },
  ],
  'copy': [
    { d: 'M3 1H11C12.105 1 13 1.895 13 3V11C13 12.105 12.105 13 11 13H3C1.895 13 1 12.105 1 11V3C1 1.895 1.895 1 3 1Z', x: 8, y: 8 },
    { d: 'M13 7V3C13 2.47 12.789 1.961 12.414 1.586C12.039 1.211 11.53 1 11 1H3C2.47 1 1.961 1.211 1.586 1.586C1.211 1.961 1 2.47 1 3V11C1 11.53 1.211 12.039 1.586 12.414C1.961 12.789 2.47 13 3 13H7', x: 2, y: 2 },
  ],
  'close': [
    { d: 'M1 1L13 13', x: 5, y: 5 },
    { d: 'M13 1L1 13', x: 5, y: 5 },
  ],
  'leave': [
    { d: 'M7 17H3C2.47 17 1.961 16.789 1.586 16.414C1.211 16.039 1 15.53 1 15V3C1 2.47 1.211 1.961 1.586 1.586C1.961 1.211 2.47 1 3 1H7', x: 3, y: 3 },
    { d: 'M1 9L5 5L1 1', x: 14, y: 7 },
    { d: 'M11 1H1', x: 8, y: 11 },
  ],
  'back': [
    { d: 'M15 1H1', x: 4, y: 11 },
    { d: 'M7 1L1 7L7 13', x: 4, y: 5 },
  ],
  'plus': [
    { d: 'M1 1V15', x: 11, y: 4 },
    { d: 'M1 1H15', x: 4, y: 11 },
  ],
  'brush': [
    { d: 'M1 16L2 12L13 1L16 4L5 15L1 16Z', x: 3, y: 4 },
    { d: 'M1 1L4 4', x: 13, y: 6 },
  ],
  'away': [
    { d: 'M1 1L19 19', x: 2, y: 2 },
    { d: 'M1 2.429C1.935 1.513 3.191 1 4.5 1C5.809 1 7.065 1.513 8 2.429', x: 7.5, y: 13.785 },
    { d: 'M1 3.3C2.136 2.232 3.506 1.445 5 1', x: 4, y: 8.85 },
    { d: 'M3.4 2.7C2.688 2.018 1.879 1.446 1 1', x: 15.3, y: 9.65 },
    { d: 'M1 1H1.01', x: 11.005, y: 19 },
  ],
  'mine': [
    { d: 'M6 11C8.761 11 11 8.761 11 6C11 3.239 8.761 1 6 1C3.239 1 1 3.239 1 6C1 8.761 3.239 11 6 11Z', x: 6, y: 6, fill: true },
    { d: 'M1 1V4', x: 11, y: 2 },
    { d: 'M1 1V4', x: 11, y: 17 },
    { d: 'M1 1H4', x: 2, y: 11 },
    { d: 'M1 1H4', x: 17, y: 11 },
    { d: 'M1 1L3.1 3.1', x: 4.15, y: 4.15 },
    { d: 'M1 1L3.1 3.1', x: 14.85, y: 14.85 },
    { d: 'M1 3.1L3.1 1', x: 4.15, y: 14.85 },
    { d: 'M1 3.1L3.1 1', x: 14.85, y: 4.15 },
  ],
  'user': [
    { d: 'M9 5C9 7.209 7.209 9 5 9C2.791 9 1 7.209 1 5C1 2.791 2.791 1 5 1C7.209 1 9 2.791 9 5Z', x: 7, y: 3 },
    { d: 'M1 9C1 6.878 1.843 4.843 3.343 3.343C4.843 1.843 6.878 1 9 1C11.122 1 13.157 1.843 14.657 3.343C16.157 4.843 17 6.878 17 9', x: 3, y: 12 },
  ],
  'chat': [
    { d: 'M1 1H17V12H6L1 16V1Z', x: 3, y: 4 },
  ],
  'link': [
    { d: 'M1 10.881C1.372 11.258 1.816 11.559 2.305 11.764C2.794 11.968 3.32 12.074 3.85 12.074C4.38 12.074 4.906 11.968 5.395 11.764C5.884 11.559 6.328 11.258 6.7 10.881L9.7 7.881C10.456 7.125 10.881 6.099 10.881 5.031C10.881 3.962 10.456 2.936 9.7 2.181C8.944 1.425 7.919 1 6.85 1C5.781 1 4.756 1.425 4 2.181L3 3.181', x: 8.94, y: 2.655 },
    { d: 'M10.881 2.193C10.508 1.815 10.065 1.515 9.575 1.31C9.086 1.106 8.561 1 8.031 1C7.5 1 6.975 1.106 6.486 1.31C5.996 1.515 5.553 1.815 5.181 2.193L2.181 5.193C1.425 5.949 1 6.974 1 8.043C1 9.112 1.425 10.137 2.181 10.893C2.936 11.649 3.962 12.074 5.031 12.074C6.099 12.074 7.125 11.649 7.881 10.893L8.881 9.893', x: 3.06, y: 7.345 },
  ],
  'edit': [
    { d: 'M1 16H5L16 5L12 1L1 12V16Z', x: 3, y: 4 },
  ],
  'flag': [
    { d: 'M1 1V18', x: 5, y: 2.5 },
    { d: 'M1 1L12 5.5L1 10V1Z', x: 5, y: 2.5, fill: true },
  ],
  'dice': [
    { d: 'M4 1H14C15.657 1 17 2.343 17 4V14C17 15.657 15.657 17 14 17H4C2.343 17 1 15.657 1 14V4C1 2.343 2.343 1 4 1Z', x: 3, y: 3 },
    { d: 'M1.5 1C1.776 1 2 1.224 2 1.5C2 1.776 1.776 2 1.5 2C1.224 2 1 1.776 1 1.5C1 1.224 1.224 1 1.5 1Z', x: 7, y: 7, fill: true },
    { d: 'M1.5 1C1.776 1 2 1.224 2 1.5C2 1.776 1.776 2 1.5 2C1.224 2 1 1.776 1 1.5C1 1.224 1.224 1 1.5 1Z', x: 10.5, y: 10.5, fill: true },
    { d: 'M1.5 1C1.776 1 2 1.224 2 1.5C2 1.776 1.776 2 1.5 2C1.224 2 1 1.776 1 1.5C1 1.224 1.224 1 1.5 1Z', x: 14, y: 14, fill: true },
  ],
  'forward': [
    { d: 'M15 1H1', x: 4, y: 11 },
    { d: 'M1 1L7 7L1 13', x: 12, y: 5 },
  ],
  'sound': [
    { d: 'M9 1L4 5H1V11H4L9 15V1Z', x: 2, y: 4 },
    { d: 'M1 1C2.757 2.757 2.757 5.607 1 7.364', x: 13.84, y: 7.5 },
    { d: 'M1 1C4.32 4.32 4.32 9.7 1 13.02', x: 16.755, y: 4.5 },
  ],
  'sound-off': [
    { d: 'M9 1L4 5H1V11H4L9 15V1Z', x: 2, y: 4 },
    { d: 'M0.707 0.707L6.707 6.707', x: 14, y: 8 },
    { d: 'M6.707 0.707L0.707 6.707', x: 14, y: 8 },
  ],
} as const satisfies Record<string, readonly GlyphPath[]>;

export type GlyphName = keyof typeof glyphs;
